import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import AuthPage from "@/pages/AuthPage";
import Dashboard from "@/pages/Dashboard";
import Analyze from "@/pages/Analyze";
import Fields from "@/pages/Fields";
import Weather from "@/pages/Weather";
import PestDoctor from "@/pages/PestDoctor";
import FieldMap from "@/pages/FieldMap";
import SharedView from "@/pages/SharedView";
import Offline from "@/pages/Offline";
import Groups from "@/pages/Groups";
import Ask from "@/pages/Ask";
import Market from "@/pages/Market";
import { Sprout } from "lucide-react";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="flex flex-col items-center gap-3 text-primary animate-pulse">
          <Sprout className="h-10 w-10" />
          <span className="font-display font-semibold">Loading AgroTerra…</span>
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="bottom-right" richColors />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<AuthPage mode="login" />} />
            <Route path="/register" element={<AuthPage mode="register" />} />
            <Route path="/app" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/app/analyze" element={<ProtectedRoute><Analyze /></ProtectedRoute>} />
            <Route path="/app/fields" element={<ProtectedRoute><Fields /></ProtectedRoute>} />
            <Route path="/app/weather" element={<ProtectedRoute><Weather /></ProtectedRoute>} />
            <Route path="/app/pest" element={<ProtectedRoute><PestDoctor /></ProtectedRoute>} />
            <Route path="/app/map" element={<ProtectedRoute><FieldMap /></ProtectedRoute>} />
            <Route path="/app/offline" element={<ProtectedRoute><Offline /></ProtectedRoute>} />
            <Route path="/app/groups" element={<ProtectedRoute><Groups /></ProtectedRoute>} />
            <Route path="/app/ask" element={<ProtectedRoute><Ask /></ProtectedRoute>} />
            <Route path="/app/market" element={<ProtectedRoute><Market /></ProtectedRoute>} />
            <Route path="/share/:token" element={<SharedView />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
